import {
  asyncActionFinish,
  asyncActionError,
} from '../../../../app/common/reduxs/async/asyncActions';
import {
  categoriesGet,
  categoryAdd,
  categoryEdit,
  categoryGet,
  categoryDelete,
} from './reduxAction';
import { ASYNC_ACTION_START } from '../../../../app/common/reduxs/async/asyncConstant';
import { checkErr } from '../../../../app/common/helpers/checkRes';
import { fetchFunc } from '../../../../app/common/helpers/fetchHelpers';

export const getCategories = (
  auth,
  history,
  itemPerPage,
  currentPage,
  searchText
) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getCategories' });
    const formData = new FormData();
    formData.append('itemPerPage', itemPerPage ? itemPerPage : 10);
    formData.append('currentPage', currentPage);
    formData.append('searchText', searchText);
    try {
      const res = await fetchFunc(
        'gets',
        auth,
        history,
        'category/',
        formData,
        dispatch
      );
      const items = res.items;
      const total = res.total;
      const search = {
        currentPage,
        searchText,
        itemPerPage: itemPerPage ? itemPerPage : 10,
      };
      dispatch(categoriesGet({ total, items, search }));
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const addCategory = (auth, history, values) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'addCategory' });
    const formData = new FormData();
    formData.append('title', values.title);
    formData.append('description', values.description);
    try {
      const res = await fetchFunc(
        'add',
        auth,
        history,
        'category/add/',
        formData,
        dispatch
      );
      const category = res.category;
      dispatch(categoryAdd(category));
      history.push('/website/category/' + category.id);
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const getCategory = (auth, history, id) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getCategory' });
    const formData = new FormData();
    try {
      const res = await fetchFunc(
        'get',
        auth,
        history,
        'category/detail/' + id,
        formData,
        dispatch
      );
      const category = res.category;
      dispatch(categoryGet(category));
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const editCategory = (auth, history, values) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'editCategory' });
    const formData = new FormData();
    formData.append('title', values.title);
    formData.append(
      'description',
      values.description ? values.description : undefined
    );
    try {
      const res = await fetchFunc(
        'edit',
        auth,
        history,
        'category/edit/' + values.id,
        formData,
        dispatch
      );
      const category = res.category;
      dispatch(categoryEdit(category));
      history.push('/website/category/' + values.id);
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const statusCategory = (auth, history, values) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'statusCategory' });
    const formData = new FormData();
    formData.append('status', values.status);
    try {
      const res = await fetchFunc(
        'edit',
        auth,
        history,
        'category/status/' + values.id,
        formData,
        dispatch
      );
      const category = res.category;
      dispatch(categoryEdit(category));
      history.push('/website/category/' + values.id);
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const deleteCategory = (auth, history, id) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'deleteCategory' });
    const formData = new FormData();
    try {
      const res = await fetchFunc(
        'delete',
        auth,
        history,
        'category/delete/' + id,
        formData,
        dispatch
      );
      const category = res.category;
      dispatch(categoryDelete(category));
      history.push('/website/category');
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};
